//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const ExamService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/exam/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveExam: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/exam/edit/save", vo, successCallback, failureCallback);
    }
};

export default ExamService;